// Vendor libraries
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
// Constants
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
// NgRx
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { getCurrentWizardStep, getCurrentWizardStepIndex, getSections, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { setSections } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/sections/sections.actions';
// Interfaces / enums
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
import * as i3 from "@angular/forms";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
function SelectSectionsModalComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 16)(2, "label", 17)(3, "input", 18);
    i0.ɵɵtwoWayListener("ngModelChange", function SelectSectionsModalComponent_div_11_Template_input_ngModelChange_3_listener($event) { const section_r2 = i0.ɵɵrestoreView(_r1).$implicit; i0.ɵɵtwoWayBindingSet(section_r2.selected, $event) || (section_r2.selected = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 19)(5, "span", 20);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const section_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipPlacement", "bottom")("tooltipTitle", section_r2.required ? ctx_r2.requiredTooltipTitle : "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", section_r2.required);
    i0.ɵɵtwoWayProperty("ngModel", section_r2.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", section_r2.title);
} }
function SelectSectionsModalComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵlistener("click", function SelectSectionsModalComponent_div_16_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.back()); });
    i0.ɵɵtext(1, "Back");
    i0.ɵɵelementEnd();
} }
export class SelectSectionsModalComponent {
    constructor(store) {
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.modalOpen = false;
        this.currentWizardStepIndex = 0;
        this.currentWizardStep = null;
        this.sections = [];
        this.requiredTooltipTitle = 'This content is required by your administrator';
        this.mapStateToComponent = (state) => {
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.currentWizardStep = getCurrentWizardStep(state);
            this.sections = getSections(state).map((section) => {
                return {
                    ...section,
                    selected: true,
                };
            });
            if (!this.modalOpen &&
                this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_SELECT_SECTIONS_MODAL) {
                this.openModal();
            }
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    openModal() {
        this.modalOpen = true;
    }
    exitModalHandler() {
        this.store.dispatch(resetAllCustomPdfReportItems());
        this.closeModal();
    }
    closeModal() {
        this.modalOpen = false;
    }
    back() {
        this.store.dispatch(decrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
        this.closeModal();
    }
    forward() {
        this.store.dispatch(setSections({
            sections: this.sections.map((section) => {
                return {
                    id: section.id,
                    title: section.title,
                    modules: section.modules,
                    hidden: !section.selected,
                };
            }),
        }));
        this.store.dispatch(incrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
        this.closeModal();
    }
}
SelectSectionsModalComponent.ɵfac = function SelectSectionsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectSectionsModalComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
SelectSectionsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectSectionsModalComponent, selectors: [["ycn-select-sections-modal"]], outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 18, vars: 6, consts: [[3, "closeModalHandler", "modalBaseClass", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section", "pb-10"], [1, "table", "file-table"], [1, "thead"], [1, "tr"], [1, "td", "col-12", "border-0"], [1, "d-inline-block", "pb-10", "pt-12", "text-bold"], [1, "tbody"], ["class", "tr", 4, "ngFor", "ngForOf"], [1, "modal-footer"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], ["class", "btn btn-secondary", 3, "click", 4, "ngIf"], [1, "btn", "btn-primary", 3, "click", "innerText"], [1, "td", "col-12"], ["ycnTooltip", "", 1, "custom-control", "custom-checkbox", 3, "tooltipPlacement", "tooltipTitle"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "disabled", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "textContent"], [1, "btn", "btn-secondary", 3, "click"]], template: function SelectSectionsModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function SelectSectionsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function SelectSectionsModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "div", 7)(8, "span", 8);
        i0.ɵɵtext(9, "Name");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵtemplate(11, SelectSectionsModalComponent_div_11_Template, 6, 5, "div", 10);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(12, "div", 11)(13, "div", 12)(14, "div", 13);
        i0.ɵɵlistener("click", function SelectSectionsModalComponent_Template_div_click_14_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵtext(15, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, SelectSectionsModalComponent_div_16_Template, 2, 0, "div", 14);
        i0.ɵɵelementStart(17, "div", 15);
        i0.ɵɵlistener("click", function SelectSectionsModalComponent_Template_div_click_17_listener() { return ctx.forward(); });
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Select Sections");
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngForOf", ctx.sections);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.currentWizardStepIndex);
        i0.ɵɵadvance();
        i0.ɵɵproperty("innerText", "Next");
    } }, dependencies: [i2.NgForOf, i2.NgIf, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgModel, i4.ModalBaseComponent, i5.SimpleModalHeaderComponent, i6.TooltipDirective], encapsulation: 2 });
